module.exports = __webpack_public_path__ + "img/progress_011.d8a3a786.png";